module.exports = __webpack_public_path__ + "img/4d1ea1d5d7c66f1e29b9224b5c363c92.svg";